import { createContext, useContext } from 'react';
import type { Me, Workspace } from '@/api/types';
import type { AbilityAction, AbilitySubject, AppAbility } from './ability';

export interface AuthValue {
  user: Me;
  /** The client workspace being worked in (for super admins: the one they opened, if any). */
  workspace: Workspace | null;
  /** Platform staff: creates and manages client workspaces. */
  isPlatformAdmin: boolean;
  /** CASL ability built from the rules the API sent with /auth/me. */
  ability: AppAbility;
  can: (action: AbilityAction, subject: AbilitySubject) => boolean;
  /** Super admins: open a client workspace / go back to the platform console. */
  enterWorkspace: (workspaceId: string) => void;
  leaveWorkspace: (opts?: { navigate?: boolean }) => void;
}

export const AuthContext = createContext<AuthValue | null>(null);

export function useAuth(): AuthValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside <RequireAuth>');
  return ctx;
}
